const capitalizeFirstLetter = (string) => {
  const newString = string.toLowerCase();
  return newString[0].toUpperCase() + newString.slice(1);
};

export default capitalizeFirstLetter;
